import { render, staticRenderFns } from "./InformasiPo.vue?vue&type=template&id=53d887b2&"
import script from "./InformasiPo.vue?vue&type=script&lang=js&"
export * from "./InformasiPo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports